import React from 'react';
import DashboardItem from 'features/dashboard/models/DashboardItem';
import DashboardSectionProps from 'features/dashboard/models/DashboardSectionProps';
import { DashboardSectionTypesMap } from './DashboardSectionTypesMap';
import { loadModule } from 'features/shared/helpers/modules';

const dashboardItems = loadModule<DashboardItem[]>("dashboard/items.json");

const DashboardMainSection = () => {
  // sub-renders
  const renderDashboardItems = (): JSX.Element[] => {
    let result: JSX.Element[] = [];

    for (let i = 0; i < dashboardItems.length; i++) {
      const item = dashboardItems[i];
      const sectionToRender = DashboardSectionTypesMap[item.component];

      if (sectionToRender !== undefined) {
        const elem = renderDashboardSection(sectionToRender, item, i);
        result.push(elem);
      } else {
        console.warn(`Component with name '${item.component}' doesn't exists.`);
      }
    }

    return result;
  }

  const renderDashboardSection = (section: (props: DashboardSectionProps) => JSX.Element | null, item: DashboardItem, index: number): JSX.Element => {
    let sectionElem = section({...item});
    
    if (sectionElem !== null) {
      return (
        <div className={`px-2 ${item.className}`} key={index}>
          {sectionElem}
        </div>
      );   
    }

    return <></>;
  }

  // render
  return (
    <div className="row no-gutters mx-n2">
      {renderDashboardItems()}
    </div>
  );
}

export default DashboardMainSection;
